/* eslint-disable consistent-return */
import { Box, Fade, makeStyles, Paper } from '@material-ui/core';
import ActiveChat from '@src/components/ActiveChat/index';
import { LAYOUT_PADDING_WIDTH } from '@src/components/AgentConsole/Layout/Utils';
import AgentToolbar from '@src/components/AgentToolbar';
import ComposerToolbar from '@src/components/ChatMessageComposer/ComposerToolbar';
import useCallAgentPermissionFlags from '@src/hooks/call/useCallAgentPermissionFlags';
import useCallRingtone from '@src/hooks/call/useCallRingtone';
import useCallStatusFlags from '@src/hooks/call/useCallStatusFlags';
import { selectPreferredCall } from '@src/selectors/calls';
import { SnackbarProvider } from 'notistack';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EventsWithAudio from '../EventsWithAudio';
import CallSection from './CallSection/CallSection';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: `${LAYOUT_PADDING_WIDTH}px`,
    height: '100%',
  },
  timelineContent: {
    height: 'inherit',
    width: '100%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: '0px 8px 8px 0px #00000014',
    borderRadius: '8px',
  },
  activeChatSection: {
    height: '100%',
    borderRadius: 0,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.background.default
        : undefined,
    backgroundImage: theme.palette.type === 'dark' ? 'none' : undefined,
  },
}));

const TimelineSection: React.FC = () => {
  const { container, timelineContent, activeChatSection } = useStyles();
  const call = useSelector(selectPreferredCall);
  const callStatusFlags = useCallStatusFlags(call?.status);
  const { isVisible } = useCallAgentPermissionFlags();

  useCallRingtone();

  const isShowCallSection = useMemo(
    () =>
      !!call?.id &&
      (callStatusFlags.isCallWaitingAgent ||
        callStatusFlags.isCallWaitingAnswer ||
        callStatusFlags.isCallOngoing),
    [call, callStatusFlags]
  );

  return (
    <SnackbarProvider maxSnack={2} preventDuplicate>
      <Box className={container}>
        <Box className={timelineContent}>
          <AgentToolbar />

          <Paper className={activeChatSection} elevation={1}>
            <ActiveChat />
            <div id="chat-timeline" style={{ position: 'relative' }} />
          </Paper>

          <ComposerToolbar />
        </Box>
        {isVisible && isShowCallSection && (
          <Fade in>
            <CallSection call={call!} />
          </Fade>
        )}
      </Box>
      <EventsWithAudio />
    </SnackbarProvider>
  );
};

export default TimelineSection;
